module.exports = __webpack_public_path__ + "static/img/biansuqi.69fb15ea.svg";